(() => {
  const PAGE_PATH = '/pages/m17-m416-physical-recoil-controllers';
  if (!window.location.pathname.endsWith(PAGE_PATH)) return;
  if (window.__WF_GEMPAGES_ATC_V17__) return;
  window.__WF_GEMPAGES_ATC_V17__ = true;

  const BUTTON_SELECTOR = '.wf-atc-button[data-variant-id]';
  const BUTTON_LABELS = {
    '53143482925372': 'Add M17 to Cart',
    '53969352753468': 'Add M416 to Cart',
    '53969352786236': 'Add Bundle to Cart'
  };
  let requestInFlight = false;
  let cartCount = 0;

  function getCartUI() {
    return document.querySelector('cart-drawer') ||
      document.querySelector('cart-notification');
  }

  async function getReadyCartUI() {
    let cartUI = getCartUI();
    if (cartUI?.tagName === 'CART-DRAWER' &&
        typeof cartUI.renderContents !== 'function' &&
        window.customElements) {
      await Promise.race([
        customElements.whenDefined('cart-drawer'),
        new Promise((resolve) => window.setTimeout(resolve, 5000))
      ]);
      cartUI = getCartUI();
    }
    return cartUI;
  }

  function getQuantity(button) {
    const value = Number(button.dataset.quantity || 1);
    return Number.isFinite(value) && value > 0 ? Math.floor(value) : 1;
  }

  function setCartCount(value) {
    cartCount = Number.isFinite(Number(value)) ? Math.max(0, Number(value)) : 0;
    document.querySelectorAll('.wf-gp-header__cart-count').forEach((badge) => {
      badge.textContent = cartCount > 99 ? '99+' : String(cartCount);
      badge.hidden = cartCount === 0;
    });
  }

  function countFromCartBubble(root = document) {
    const bubble = root.querySelector?.('.cart-count-bubble');
    if (!bubble) return null;
    const visibleCount = bubble.querySelector('[aria-hidden="true"]')?.textContent.match(/\d+/)?.[0];
    if (visibleCount) return Number(visibleCount);
    const matches = bubble.textContent.match(/\d+/g);
    return matches ? Number(matches.at(-1)) : null;
  }

  async function refreshCartCount(forceFetch = false) {
    if (!forceFetch) {
      const bubbleCount = countFromCartBubble();
      if (bubbleCount !== null) {
        setCartCount(bubbleCount);
        return;
      }
    }

    try {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) return;
      const currentCart = await response.json();
      setCartCount(currentCart.item_count);
    } catch (error) {
      console.warn('[Wonderfitter cart count]', error);
    }
  }

  function updateCountFromSections(sections) {
    const html = sections?.['cart-icon-bubble'];
    if (!html) {
      void refreshCartCount();
      return;
    }

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const count = countFromCartBubble(parsed);
    if (count !== null) setCartCount(count);
    else setCartCount(0);
  }

  function openCartDrawer(cartUI) {
    if (cartUI?.tagName !== 'CART-DRAWER') return false;

    cartUI.classList.remove('is-empty');
    cartUI.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');

    cartUI.scrollTop = 0;
    const drawerInner = cartUI.querySelector('.drawer__inner');
    if (drawerInner) drawerInner.scrollTop = 0;
    cartUI.querySelector('[role="dialog"]')?.focus({ preventScroll: true });
    return true;
  }

  function closeCartDrawer(cartUI) {
    if (cartUI?.tagName !== 'CART-DRAWER') return;
    cartUI.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  async function fetchFreshCartSections() {
    const response = await fetch(
      `${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`,
      {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      }
    );

    if (!response.ok) throw new Error('Unable to refresh cart sections.');
    const contentType = response.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) {
      throw new Error('Cart sections response was not JSON.');
    }
    return response.json();
  }

  function renderFallbackCartDrawer(cartUI, sections, button) {
    const html = sections?.['cart-drawer'];
    if (html && cartUI?.tagName === 'CART-DRAWER') {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const incoming = parsed.querySelector('cart-drawer');
      if (incoming) {
        cartUI.innerHTML = incoming.innerHTML;
        cartUI.className = incoming.className;
        openCartDrawer(cartUI);
        window.requestAnimationFrame(() => openCartDrawer(cartUI));
        return true;
      }
    }

    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { source: 'wonderfitter-atc', trigger: button }
    }));
    return false;
  }

  function getHeaderShell(logo) {
    let candidate = logo.closest('a')?.parentElement;
    let bestMatch = null;
    while (candidate && candidate !== document.body) {
      const rect = candidate.getBoundingClientRect();
      if (rect.top >= -2 && rect.top < 100 &&
          rect.width > 0 && rect.height > 0 && rect.height < 240 &&
          (!bestMatch || rect.width > bestMatch.rect.width)) {
        bestMatch = { element: candidate, rect };
      }
      candidate = candidate.parentElement;
    }
    return bestMatch?.element || null;
  }

  function findHeaderLogo() {
    const images = [...document.images];
    const candidates = images.filter((image) => {
      const source = [
        image.currentSrc,
        image.src,
        image.dataset.src,
        image.dataset.lazySrc
      ].filter(Boolean).join(' ');
      return source.includes('logo18x2.42cm5454.png') || source.includes('image_demo.jpg');
    });
    return candidates.find((image) => {
      const rect = image.getBoundingClientRect();
      return rect.top >= 0 && rect.top < 140 && rect.width > 0 && rect.height > 0;
    }) || images.find((image) => {
      const rect = image.getBoundingClientRect();
      return rect.top >= 0 && rect.top < 120 && rect.width >= 60 && rect.height >= 8 && rect.height <= 80;
    }) || candidates[0];
  }

  function createCartButton() {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'wf-gp-header__cart';
    button.setAttribute('aria-label', 'View cart');
    button.innerHTML = `
      <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M6 8h12l-1 12H7L6 8Z"></path>
        <path d="M9 8V6a3 3 0 0 1 6 0v2"></path>
      </svg>
      <span class="wf-gp-header__cart-count" hidden>0</span>
    `;
    button.addEventListener('click', async () => {
      const cartUI = await getReadyCartUI();
      if (cartUI && typeof cartUI.open === 'function') {
        cartUI.open(button);
        return;
      }
      if (openCartDrawer(cartUI)) return;
      window.location.assign('/cart');
    });
    return button;
  }

  function enhanceHeaderAndButtons() {
    document.querySelectorAll(BUTTON_SELECTOR).forEach((button) => {
      const label = BUTTON_LABELS[button.dataset.variantId];
      if (label && button.textContent.trim() !== label) button.textContent = label;
    });

    const logo = findHeaderLogo();
    if (!logo) return;

    logo.classList.add('wf-gp-header__logo-image');
    const headerShell = getHeaderShell(logo);
    if (!headerShell) return;

    headerShell.classList.add('wf-gp-header-shell');
    const visibleLabels = [...headerShell.querySelectorAll('a')]
      .filter((link) => link.getBoundingClientRect().width > 0)
      .map((link) => link.textContent.trim());
    const isMobileHeader = headerShell.getBoundingClientRect().width <= 760 ||
      visibleLabels.includes('Features');
    headerShell.classList.toggle('wf-gp-header-shell--mobile', isMobileHeader);
    document.querySelectorAll('.wf-gp-header__cart').forEach((cartButton) => {
      if (cartButton.parentElement !== headerShell) cartButton.remove();
    });
    if (!headerShell.querySelector(':scope > .wf-gp-header__cart')) {
      headerShell.append(createCartButton());
    }
    setCartCount(cartCount);
  }

  function scheduleEnhancements(attempt = 0) {
    enhanceHeaderAndButtons();
    const hasVisibleCartButton = [...document.querySelectorAll('.wf-gp-header__cart')]
      .some((button) => button.getBoundingClientRect().width > 0);
    if (!hasVisibleCartButton && attempt < 20) {
      window.setTimeout(() => scheduleEnhancements(attempt + 1), 250);
    }
  }

  async function addToCart(button) {
    if (requestInFlight || button.disabled) return;

    const variantId = Number(button.dataset.variantId);
    if (!Number.isInteger(variantId) || variantId <= 0) {
      console.error('[Wonderfitter ATC] Invalid variant ID.');
      return;
    }

    requestInFlight = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    const cartUI = await getReadyCartUI();
    const formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(getQuantity(button)));

    const sections = cartUI && typeof cartUI.getSectionsToRender === 'function'
      ? cartUI.getSectionsToRender().map((section) => section.id)
      : ['cart-drawer', 'cart-icon-bubble'];
    formData.append('sections', sections.join(','));
    formData.append('sections_url', window.location.pathname);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Unable to add item.');
      }

      let freshSections = result.sections;
      try {
        await new Promise((resolve) => window.setTimeout(resolve, 150));
        const refreshedSections = await fetchFreshCartSections();
        freshSections = { ...result.sections };
        Object.entries(refreshedSections || {}).forEach(([key, value]) => {
          if (typeof value === 'string' && value.trim()) freshSections[key] = value;
        });
      } catch (refreshError) {
        console.warn('[Wonderfitter cart refresh]', refreshError);
      }

      renderFallbackCartDrawer(cartUI, freshSections, button);
      updateCountFromSections(freshSections);
    } catch (error) {
      console.error('[Wonderfitter ATC]', error);
      window.alert(error.message || 'Unable to add this item. Please try again.');
    } finally {
      requestInFlight = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    const drawerClose = target?.closest('cart-drawer .drawer__close, cart-drawer .cart-drawer__overlay');
    if (drawerClose) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      closeCartDrawer(drawerClose.closest('cart-drawer'));
      return;
    }
    const drawerQuantityControl = target?.closest(
      'cart-drawer .quantity__button, cart-drawer cart-remove-button, cart-drawer [data-cart-remove]'
    );
    if (drawerQuantityControl) {
      window.setTimeout(() => void refreshCartCount(true), 800);
      window.setTimeout(() => void refreshCartCount(true), 1800);
    }
    const button = target?.closest(BUTTON_SELECTOR);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    void addToCart(button);
  }, true);

  document.addEventListener('change', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (target?.matches('cart-drawer input[name="updates[]"]')) {
      window.setTimeout(() => void refreshCartCount(true), 800);
      window.setTimeout(() => void refreshCartCount(true), 1800);
    }
  });

  scheduleEnhancements();
  void refreshCartCount();
  document.addEventListener('shopify:section:load', () => scheduleEnhancements());

  const cartBubble = document.querySelector('#cart-icon-bubble')?.parentElement;
  if (cartBubble) {
    new MutationObserver(() => {
      const count = countFromCartBubble();
      if (count !== null) setCartCount(count);
      else setCartCount(0);
    }).observe(cartBubble, { childList: true, subtree: true, characterData: true });
  }
})();
